import { Component } from '@basic-orange/component';
const LIVECHAT_ALLOWED_KEY = 'livechatAllowed';
const LIVECHAT_ACTIVE_KEY = 'livechatActive';
const LAST_CHAT_KEY = 'lastActiveChat';
export default class Chatbot extends Component {
    constructor(elm, componentId) {
        super(elm, componentId);

        this.settings = this.data;
        this.currentLocation = document.location.href;

        this.lastPageVisited = sessionStorage.getItem('lastpage');

        if (!this.lastPageVisited) {
            sessionStorage.setItem('lastpage', this.currentLocation);
            this.lastPageVisited = this.currentLocation;
        }
        this.setPage(this.currentLocation, this.lastPageVisited);
        this.setConfig(this.data);


        window.userlike = window.userlike || [];

        const wasLiveChat = sessionStorage.getItem(LIVECHAT_ACTIVE_KEY) === 'true';
        const allowed = sessionStorage.getItem(LIVECHAT_ALLOWED_KEY) === 'true';

        if (wasLiveChat && allowed) {
            window.userlike.push(['cmd', 'open']);
        }

        this.loadCxScript();

        this.widgets = document.querySelectorAll('.widget-chatbot');

        this.onChatbotReady(this.data);
        this.initWidgets();
        this.initUserlikeEvents();

        const userlikeSafe = {
            open() {
                if (window.userlike?.openChat) {
                    window.userlike.openChat();
                } else if (Array.isArray(window.userlike)) {
                    window.userlike.push(['cmd', 'open']);
                }
            },
            onEvent(handler) {
                if (window.userlike?.onEvent) {
                    window.userlike.onEvent(handler);
                } else if (Array.isArray(window.userlike)) {
                    window.userlike.push(['onEvent', handler]);
                }
            }
        };

    }

    setConfig(data) {
        window.cxcoConfig = {
            /* project/database configuration */
            /* engineUrl: 'cms', */
            session: {
                mode: this.settings.context,
                pageUrl: this.currentLocation
            },
            project: {
                publicApiKey: data.apikey,
                culture: data.language,
                customerKey: data.customerkey,
                key: data.projectkey
            },
            dci: {
                onloadEvent: data.dialogtostart,
                layout: {
                    scrollType: 'answer',
                    initialState: this.getStorageItem(),
                    inputPlaceholder: data.placeholder,
                    rows: 1,
                    dialogChooseAgain: data.chooseagain,
                    dialogNewChoice: data.newchoice,
                    showAvatar: true,
                    title: data.title,
                    isMenuOpen: true,
                    persistentState: true,
                    initialHeight: 34
                },
                feedback: {
                    /* Show global feedback on separate panel. default - false */
                    showGlobal: false,
                    /* Show interaction feedback - thumbs up/down. default - false  */
                    showThumbs: false,
                    /* Trigger default feedback on QA and dialog. default - false */
                    showDialog: true
                }
            }
        };

        window.cxco = window.cxco || [];
    }

    onChatbotReady(data) {
        cxco.push(['on', 'chatbot.ready', function () {
            try {
                //create element nodes
                window.buttonNode = document.createElement('button');
                window.overlayNode = document.createElement('div');
                window.closeButtonNode = document.createElement('div');
                window.inputCounterNode = document.createElement('div');

                window.overlayTitleNode = document.createElement('h2');
                window.overlayTextNode = document.createElement('div');
                window.overlayButtonNode = document.createElement('button');
                window.overlayLinkNode = document.createElement('a');
                window.closeButtonTextEl = JSON.parse(sessionStorage.getItem('cxco.dci')).messages.length ? data.buttonresumetext : data.buttoninittext;

                // add classes to element nodes
                overlayTextNode.classList.add('cxco-c-overlay-text');
                overlayButtonNode.classList.add('cxco-c-overlay-button');
                overlayLinkNode.classList.add('cxco-c-overlay-link');
                buttonNode.classList.add('cxco-c-open');
                overlayNode.classList.add('cxco-c-overlay');
                overlayNode.classList.add('closed');
                closeButtonNode.classList.add('cxco-c-action__text');
                inputCounterNode.classList.add('characters-left');

                // create text nodes
                window.overlayTitleText = document.createTextNode(data.overlaytitle);
                window.overlayText = document.createTextNode(data.overlaytext);
                window.overlayButtonText = document.createTextNode(data.overlaybuttontext);
                window.overlayLinkText = document.createTextNode(data.overlaylinktext);
                window.closeButtonText = document.createTextNode(closeButtonTextEl);
                window.inputCounterNodeText = document.createTextNode('100');

                // get chat elements
                window.parentDiv = document.getElementsByClassName('cxco-o-chat')[0];
                window.buttonCloseDiv = document.getElementsByClassName('cxco-c-action')[0];
                window.buttonMinimizeDiv = document.getElementsByClassName('cxco-c-close')[0];
                window.cxcoChatInput = document.getElementById('cxcoChatInput');
                window.cxcoChatInputParent = cxcoChatInput.parentNode;

                // add text and data nodes to element nodes
                overlayTitleNode.appendChild(overlayTitleText);
                overlayTextNode.appendChild(overlayText);
                overlayButtonNode.appendChild(overlayButtonText);
                overlayLinkNode.appendChild(overlayLinkText);
                closeButtonNode.appendChild(closeButtonText);
                buttonCloseDiv.dataset.resumetext = data.buttonresumetext;
                buttonCloseDiv.dataset.inittext = data.buttoninittext;
                inputCounterNode.appendChild(inputCounterNodeText);

                // add element nodes to overlay node
                overlayNode.appendChild(overlayTitleNode);
                overlayNode.appendChild(overlayTextNode);
                overlayNode.appendChild(overlayButtonNode);
                overlayNode.appendChild(overlayLinkNode);
                cxcoChatInputParent.appendChild(inputCounterNode);

                // Set title attribute on submit button
                const submitButton = cxcoChatInputParent.querySelector('.cxco-c-field__button:not(.cxco-u-hidden)');
                if (submitButton) submitButton.setAttribute('title', 'Submit');

                // init
                window.maxTextCharactersNumber = data.maxtextcharacters;
                updateCounter(maxTextCharactersNumber);
                setResumeButtonText('minimized', false);

                // add listners
                cxcoChatInput.onkeyup = function () {
                    updateCounter(maxTextCharactersNumber);
                };

                cxcoChatInput.onkeydown = function () {
                    updateCounter(maxTextCharactersNumber);
                };

                buttonMinimizeDiv.onclick = function () {
                    setResumeButtonText('minimized', false);
                };

                buttonCloseDiv.onclick = function () {

                    let PastDateTime = Date.parse(sessionStorage.getItem('livechatStart'));
                    let currentDateTime = Date.parse(new Date());

                    let msDifference = currentDateTime - PastDateTime;
                    let minutes = Math.floor(msDifference / 1000 / 60);
                    let days = Math.floor(minutes / 1440);
                    if (days > 0 || minutes <= 60) {
                        window.openLiveChat();
                    } else {
                        setResumeButtonText('open', false);
                    }
                };

                buttonNode.onclick = function () {
                    if (overlayNode.classList.contains('closed')) {
                        overlayNode.classList.remove('closed');
                    } else {
                        overlayNode.classList.add('closed');
                    }

                };

                overlayButtonNode.onclick = function () {
                    closeChat();
                };

                overlayLinkNode.onclick = function () {
                    overlayNode.classList.add('closed');
                };

                // append elemets to chatbot
                buttonCloseDiv.appendChild(closeButtonNode);
                parentDiv.appendChild(buttonNode);
                parentDiv.appendChild(overlayNode);

                // init buttons after elements being added
                var $openClosebutton = $('.cxco-c-open')[0];
                var $hideButton = $('.cxco-c-close')[0];

                // set attributes on buttons end text input
                $openClosebutton.setAttribute('title', data.closebuttontitle);
                $hideButton.setAttribute('title', data.hidebuttontitle);
                cxcoChatInput.setAttribute('maxLength', maxTextCharactersNumber);
                cxcoChatInput.setAttribute('rows', '1'); // start textfield centered

                // specific functions for chatbot
                window.openLiveChat = function () {

                    isOperatorAvailable().then(function (isAvailable) {
                        if (isAvailable == false) {

                            /* Livechat Operator is NIET beschikbaar*/
                            cxco.push(['answer', { data: { answer: data.livechatisclosedtext } }])

                            return;
                        }

                        // Livechat Operator is beschikbaar

                        cxco.push(['changeState', { isOpen: false }]);
                        document.querySelectorAll('div[data-test-id]')[0].style.display = 'block';
                        sessionStorage.setItem('chatbotInitState', 'minimized');
                        window.userlike.userlikeStartChat();
                        sessionStorage.setItem('livechatStart', new Date());
                        sessionStorage.setItem(LIVECHAT_ACTIVE_KEY, 'true');
                        sessionStorage.setItem(LIVECHAT_ALLOWED_KEY, 'true');
                        sessionStorage.setItem(LAST_CHAT_KEY, 'livechat');

                        setResumeButtonText('minimized', false);
                    });

                }

                function closeChat() {
                    var sendOnloadEvent = cxcoConfig.dci.onloadEvent;
                    cxco.push(['archive']);
                    cxco.push(['sendEvent', sendOnloadEvent]);
                    overlayNode.classList.add('closed');
                    cxco.push(['changeState', { isOpen: false }]);
                    setResumeButtonText('minimized', true);
                }

                function updateCounter(maxNumber) {
                    var textAreaCount = cxcoChatInput.value.length;
                    inputCounterNode.innerHTML = maxNumber - textAreaCount;
                }

                function setResumeButtonText(openOrClose, reset) {
                    sessionStorage.setItem('chatbotInitState', openOrClose);
                    const stored = sessionStorage.getItem('cxco.dci');
                    const parsed = stored ? JSON.parse(stored) : null;
                    const hasMessages = parsed?.messages?.length > 0;
                    var closedButtonData = $('.cxco-c-action')[0].data();
                    var closeButtonText = !reset ? closedButtonData.resumetext : closedButtonData.inittext;
                    $('.cxco-c-action__text').text(closeButtonText);
                    let $chatbotButtonTextElements = $('.widget-chatbotButton-text');
                    $chatbotButtonTextElements.each((id, $element) => {
                        let text = hasMessages && !reset ? $element.dataset.changedtext : $element.dataset.defaulttext;
                        $element.innerHTML = text;
                    });
                }

                async function isOperatorAvailable() {

                    if (!data.livechatorganizationid || !data.livechatwidgetid) {
                        return false;
                    }

                    const url = "https://api.userlike.com/api/um/chat/button/check/?organization_id="
                        + data.livechatorganizationid
                        + "&chat_widget_id="
                        + data.livechatwidgetid;

                    return fetch(url)
                        .then(res => res.text())
                        .then(text => {
                            const json = JSON.parse(text.slice(text.indexOf('(') + 1, text.lastIndexOf(')')));
                            return json.operator_available || json.can_start_conversation;
                        })
                        .catch(() => false);
                }

                function parseJSONP(jsonpString) {
                    // Match the first "(" and the last ")" to extract the JSON part
                    const start = jsonpString.indexOf('(') + 1;
                    const end = jsonpString.lastIndexOf(')');

                    if (start === 0 || end === -1 || end <= start) {
                        throw new Error('Invalid JSONP format');
                    }

                    const jsonString = jsonpString.slice(start, end);

                    return JSON.parse(jsonString);
                }

                // observe chat input parent for newly added input/textarea, so the event listener can be added again
                const observer = new MutationObserver(function (mutations_list) {
                    mutations_list.forEach(function (mutation) {
                        mutation.addedNodes.forEach(function (added_node) {
                            if (added_node.id == 'cxcoChatInput') {
                                window.cxcoChatInput = added_node;
                                cxcoChatInput.setAttribute('maxLength', maxTextCharactersNumber);
                                cxcoChatInput.onkeyup = function () {
                                    updateCounter(maxTextCharactersNumber);
                                };

                                observer.disconnect();
                            }
                        });
                    });
                });

                observer.observe(cxcoChatInputParent, { subtree: false, childList: true });

                // concept for keeping dialog options open

                //var $optionDialog = $('.cxco-c-dialog__option');
                //$optionDialog.on('click', function () {
                //var $button = $(this);  

                //var $buttonListItem = $button.closest('.cxco-c-dialog__item');


                //    var $buttonList = $button.closest('.cxco-c-dialog');
                //    var $buttonContainer = $button.closest('.cxco-c-conversation__node');

                //    $button.toggleClass('active');
                //    $button.data('state', '');
                //    $buttonListItem.data('state', '');
                //    $buttonList.data('state', '');
                //    $buttonContainer.find('.cxco-c-reverter').remove();

                //});



                function restoreLastChat() {

                    const lastChat = sessionStorage.getItem(LAST_CHAT_KEY);

                    const livechatActive =
                        sessionStorage.getItem(LIVECHAT_ACTIVE_KEY) === 'true' &&
                        sessionStorage.getItem(LIVECHAT_ALLOWED_KEY) === 'true';

                    if (lastChat === 'livechat' && livechatActive) {

                        cxco.push(['changeState', { isOpen: false }]);

                        let attempts = 0;


                        setTimeout(() => {
                            if (window.userlike?.openChat) {
                                window.userlike.openChat();
                            }
                        }, 500);


                        return;
                    }


                    if(lastChat === 'cxco') {

                        const state = sessionStorage.getItem('chatbotInitState');

                        cxco.push([
                            'changeState',
                            { isOpen: state === 'open' }
                        ]);
                    }


                }


                setTimeout(() => {
                    restoreLastChat();
                }, 500);



            } catch (error) {
                console.log(error);
            }

            const widgets = document.querySelectorAll('.widget-chatbot');
            let isOpen = false;
            if (sessionStorage.getItem('cxco.dci')) isOpen = JSON.parse(sessionStorage.getItem('cxco.dci')).isOpen;

            const isLiveChatActive =
                sessionStorage.getItem(LIVECHAT_ACTIVE_KEY) === 'true' &&
                sessionStorage.getItem(LIVECHAT_ALLOWED_KEY) === 'true';

            if (widgets.length && isOpen == false && isLiveChatActive == false) {
                window.buttonCloseDiv.classList.add('hide');
            } else {
                window.buttonCloseDiv.classList.remove('hide');
            }

            
        }]);

        // reset counter and send feedback on answer
        cxco.push(['on', 'answer', function (answer) {
            inputCounterNode.innerHTML = maxTextCharactersNumber;

            if (answer.data.outputAdditions && answer.data.outputAdditions.hasOwnProperty('feedbackscore')) {
                const score = parseInt(answer.data.outputAdditions['feedbackscore'])

                cxco.push(['sendEvent', 'sendFeedback',
                    data = {
                        score,
                        label: score <= 0 ? 'no' : 'yes',
                        interactionId: answer.metadata.interactionId,
                        comment: answer.data.answer.replace(/(<\/?[^>]*>)|(%{DialogOption\([^)]*\)})/gmi, '')
                    }
                ]);
            }
        }]);

        cxco.push(['on', 'ask', function (answer) {

            if (answer.data &&
                answer.data.hasOwnProperty('dialogPath') &&
                answer.data.dialogPath === '1480:2' &&
                answer.data.userInput === 'Ja, ga naar de livechat') {

                sessionStorage.setItem(LIVECHAT_ALLOWED_KEY, 'true');
                sessionStorage.setItem(LAST_CHAT_KEY, 'livechat');
                window.openLiveChat();
            }
        }]);
    }

    loadCxScript() {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://projects.elitechnology.com/jsprojects/cxco/dci/3/init.js?v=' + (+new Date);
        script.async = true;

        var scriptTag = document.getElementsByTagName('script')[0];
        scriptTag.parentNode.insertBefore(script, scriptTag);
    }

    initWidgets() {
        this.widgets.forEach($widget => {
            const $input = $widget.querySelector('.widget-chatbotField');
            const $button = $widget.querySelector('.widget-chatbotButton');

            $button.addEventListener('click', (event) => {
                event.preventDefault();

                if (window.userlike?.userlikeStopChat) {
                    window.userlike.userlikeStopChat();
                }

                sessionStorage.removeItem(LIVECHAT_ALLOWED_KEY);
                sessionStorage.removeItem(LIVECHAT_ACTIVE_KEY);

                sessionStorage.setItem(LAST_CHAT_KEY, 'cxco');
                if ($input.value) {
                    cxco.push(['ask', $input.value]);
                    $input.value = '';
                }

                cxco.push(['changeState', { isOpen: true }]);
                sessionStorage.setItem(LAST_CHAT_KEY, 'cxco');

                window.buttonCloseDiv.classList.remove('hide');
            });
        });
    }

    initUserlikeEvents() {

        const handler = (event) => {

            switch (event.type) {


                case 'chat_started':
                case 'chat_opened':
                    sessionStorage.setItem(LIVECHAT_ACTIVE_KEY, 'true');
                    sessionStorage.setItem(LAST_CHAT_KEY, 'livechat');
                    break;

                case 'chat_closed':
                    sessionStorage.removeItem(LIVECHAT_ALLOWED_KEY);
                    sessionStorage.removeItem(LIVECHAT_ACTIVE_KEY);
                    sessionStorage.setItem(LAST_CHAT_KEY, 'cxco');

                    cxco.push(['changeState', { isOpen: true }]);
                    break;


                case 'chat_hidden':

                    const shouldKeepLivechat =
                        sessionStorage.getItem(LIVECHAT_ACTIVE_KEY) === 'true' &&
                        sessionStorage.getItem(LIVECHAT_ALLOWED_KEY) === 'true';

                    if (shouldKeepLivechat) {

                        setTimeout(() => {
                            if (window.userlike?.openChat) {
                                window.userlike.openChat();
                            }
                        }, 300);

                    } else {
                        cxco.push(['changeState', { isOpen: true }]);
                    }

                    break;

            }
        };


        this.registerUserlikeEvent(handler);

    }

    setPage(currentpage, lastpage) {
        if (currentpage !== lastpage) {
            sessionStorage.setItem('lastpage', currentpage);
        }
    }


    getStorageItem() {
        const state = sessionStorage.getItem('chatbotInitState');

        if (!state) {
            sessionStorage.setItem('chatbotInitState', 'minimized');
            return 'minimized';
        }

        return state;
    }

    registerUserlikeEvent = (handler) => {

        if (Array.isArray(window.userlike)) {
            window.userlike.push(['onEvent', handler]);
            return;
        }

        if (window.userlike && typeof window.userlike.onEvent === 'function') {
            window.userlike.onEvent(handler);
            return;
        }

        // fallback wachten
        const interval = setInterval(() => {

            if (Array.isArray(window.userlike)) {
                window.userlike.push(['onEvent', handler]);
                clearInterval(interval);
            }

            if (window.userlike && typeof window.userlike.onEvent === 'function') {
                window.userlike.onEvent(handler);
                clearInterval(interval);
            }

        }, 100);
    };


}